exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirmation-container {\n    text-align: center;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #f0f0f0;\n  }\n\n  .success-message {\n    color: green;\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n\n  .thank-you-message {\n    font-size: 18px;\n  }\n.confirmation{\n    font-family: 'Arial', sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    margin: 0;\n}\n", ""]);

// exports
